import { Input } from "@/components/ui/Input";
import { useStepContext } from "@/hooks/useSetupWizard";
import * as shared from "@/styles/shared";
import { BankType } from "@shared/types/settings";
import { Building2, Lock, User } from "lucide-react";
import * as pageStyles from "../../pages/SetupWizardPage.styles";
import * as styles from "./BankStep.styles";

const BankStep = () => {
  const step = useStepContext();

  return (
    <div className={pageStyles.section}>
      <h2 className={shared.headingLg}>{step.t("step1Title")}</h2>
      <p className={shared.muted}>{step.t("step1Desc")}</p>
      <div className={shared.formStack}>
        <Input
          id="bank-name"
          label={step.t("step.bankName")}
          value={step.bankName}
          onChange={(e) => step.setState({ bankName: e.target.value })}
          placeholder={step.t("bankNamePlaceholder")}
          required
          icon={Building2}
        />
        <label className={styles.label}>{step.t("step.bankType")}</label>
        <div className={styles.bankSelector}>
          <button
            type="button"
            onClick={() => step.setState({ bankType: BankType.ASA })}
            className={`${styles.bankButton} ${step.bankType === BankType.ASA ? styles.bankButtonSelected : styles.bankButtonUnselected}`}
          >
            <img src="/assets/banks/asa.png" alt={step.t("bankASA")} className={styles.asaLogo} />
            {step.bankType === BankType.ASA && (
              <span className={styles.bankLogoWrapper}>
                <svg className={styles.bankLogoSvg} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
            )}
          </button>
          <button
            type="button"
            onClick={() => step.setState({ bankType: BankType.PROCREDIT })}
            className={`${styles.bankButton} ${step.bankType === BankType.PROCREDIT ? styles.bankButtonSelected : styles.bankButtonUnselected}`}
          >
            <img src="/assets/banks/procredit-logo.png" alt={step.t("bankProcredit")} className={styles.procreditLogo} />
            {step.bankType === BankType.PROCREDIT && (
              <span className={styles.bankLogoWrapper}>
                <svg className={styles.bankLogoSvg} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
            )}
          </button>
        </div>
        <Input
          id="bank-username"
          label={step.t("step.bankUsername")}
          value={step.bankUsername}
          onChange={(e) => step.setState({ bankUsername: e.target.value })}
          placeholder={step.t("bankUsernamePlaceholder")}
          icon={User}
        />
        <Input
          id="bank-password"
          label={step.t("step.bankPassword")}
          value={step.bankPassword}
          onChange={(e) => step.setState({ bankPassword: e.target.value })}
          placeholder={step.t("bankPasswordPlaceholder")}
          type="password"
          icon={Lock}
        />
      </div>
    </div>
  );
};

export { BankStep };
